export default "__VITE_ASSET__C34m26l7__"